import gql from 'graphql-tag';

export const UNLINK_SOCIAL_ACCOUNT_TO_MEMBER = gql`
    mutation {
        unlinkSocialAccountToMember(
            providerName: line
        )
    },
`;
